import { render, staticRenderFns } from "./addNewBranch.vue?vue&type=template&id=40b62fbc&scoped=true"
import script from "./addNewBranch.vue?vue&type=script&lang=js"
export * from "./addNewBranch.vue?vue&type=script&lang=js"
import style0 from "./addNewBranch.vue?vue&type=style&index=0&id=40b62fbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b62fbc",
  null
  
)

export default component.exports